//
//
//
//
//
//
//
//
//
//
//
//
//

import memberStep from "@/components/comRegister/memberStep";
import common_form from "@/components/comRegister/common_form";
import "@/assets/css/reset.css";
import "@/assets/css/global.css";
export default {
  components: {
    memberStep,
    common_form
  },
  data() {
    return {
      activeOpenid: "",
      dataList: [
        {
          title: "宝宝资料",
          list: [
            {
              type: "input",
              title: "宝宝姓名：",
              placeholder: "请输入宝宝姓名",
              required: true,
              value: ""
            },
            {
              type: "radio",
              title: "宝宝性别：",
              required: true,
              color: "#1aad19",
              value: "",
              radioList: [
                {
                  id: 1,
                  name: "男宝宝"
                },
                {
                  id: 2,
                  name: "女宝宝"
                }
              ]
            },
            {
              type: "radio",
              title: "与宝宝的关系：",
              required: true,
              color: "rgb(81,170,56)",
              value: "",
              radioList: [
                {
                  id: "妈妈",
                  name: "妈妈"
                },
                {
                  id: "爸爸",
                  name: "爸爸"
                },
                {
                  id: "其他",
                  name: "其他"
                }
              ]
            },
            {
              type: "dataTime",
              title: "出生日期",
              value: "",
              required: true,
              placeholder: "请选择出生日期",
              show: false,
              cur_date: new Date(),
              min_date: new Date("2012/01/01"),
              max_date: new Date()
            },
            {
              type: "input",
              title: "出生证号码：",
              placeholder: "请输入出生证号码",
              value: ""
            },
            {
              type: "upload",
              title: "出生证照片：",
              value: "",
              isAi: true,
              isCheck: false
            },
            {
              type: "radio",
              title: "喂养方式：",
              required: true,
              color: "#1aad19",
              value: "",
              radioList: [
                {
                  id: 0,
                  name: "母乳为主"
                },
                {
                  id: 1,
                  name: "奶粉为主"
                },
                {
                  id: 2,
                  name: "混合喂养"
                }
              ]
            }
          ]
        }
      ],
      stepInfo: {
        curStep: 1,
        color: "#1aad19",
        list: ["宝宝信息", "扫罐底码", "提交成功"]
      },
      queryInfo: {},
      maxBirthDate: ""
    };
  },
  created() {
    this.queryInfo = this.$route.query;
    var date = new Date();
    var year = date.getFullYear(),
      month = date.getMonth() + 1,
      day = date.getDate();
    this.maxBirthDate = new Date(year + "/" + month + "/" + day);
    console.log(this.maxBirthDate);
    // this.$msg.loading("加载中")
    this.$http({
      url: this.$api.memberGetMemberInfo,
      method: "post",
      data: {}
    }).then(res => {
      this.$msg.hideLoading();
      this.dataInfo = res.data;
      if (res.data.state == 1) {
        console.log(res.data.data.ActivityOpenId, " res.data.ActivityOpenId");
        this.activeOpenid = res.data.data.BrandOpenId;

        // this.dataList[0].list[0].value = res.data.data.BabyName
        // this.dataList[0].list[1].value = res.data.data.BabySexName
        // this.dataList[0].list[2].value = res.data.data.BabyBirthday
        // this.dataList[0].list[3].value = res.data.data.BabyBirthCertNo
        // this.dataList[0].list[4].value = res.data.data.BabyBirthCertImageFiles

        // this.dataList[0].list[5].value = res.data.data.FeedStyleName
        // this.dataList[0].list[6].value = res.data.data.MilkNumEveryMonth
        // this.dataList[1].list[0].value = res.data.data.BabyUsedBrandName

        if (this.dataList[0].list[0].value) {
          this.dataList[0].list[0].disabled = true;
        } else {
          this.dataList[0].list[0].disabled = false;
        }
        //////
        if (this.dataList[0].list[1].value) {
          this.dataList[0].list[1].disabled = true;
        } else {
          this.dataList[0].list[1].disabled = false;
        }
        ///
        if (this.dataList[0].list[2].value) {
          this.dataList[0].list[2].disabled = true;
        } else {
          this.dataList[0].list[1].disabled = false;
        }

        ////
        if (this.dataList[0].list[3].value) {
          this.dataList[0].list[3].disabled = true;
        } else {
          this.dataList[0].list[3].disabled = false;
        }
        ///
        if (this.dataList[0].list[4].value) {
          this.dataList[0].list[4].disabled = true;
        } else {
          this.dataList[0].list[4].disabled = false;
        }
        ///
        if (this.dataList[0].list[5].value) {
          this.dataList[0].list[5].disabled = true;
        } else {
          this.dataList[0].list[5].disabled = false;
        }
      }
    });
  },
  methods: {
    selectCb(val) {
      // if (val == "其他") {
      //   this.dataList[1].list[1].isHide = false;
      // } else {
      //   this.dataList[1].list[1].isHide = true;
      // }
    },
    nextStep() {
      var info = this.dataList;
      var nameReg = /^[\u4e00-\u9fa5a-zA-Z\s]+$/;
      var BrandNameReg = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/;
      if (!info[0].list[0].value) {
        this.$msg.fail("请输入宝宝姓名");
        return;
      }
      if (!nameReg.test(info[0].list[0].value)) {
        this.$msg.fail("只能填写中文或英文的姓名");
        return;
      }
      if (!info[0].list[1].value) {
        this.$msg.fail("请输入宝宝性别");
        return;
      }
      if (!info[0].list[2].value) {
        this.$msg.fail("请选择与宝宝关系");
        return;
      }
      if (!info[0].list[3].value) {
        this.$msg.fail("请输入宝宝出生日期");
        return;
      }
      if (!info[0].list[6].value) {
        this.$msg.fail("请输入宝宝喂养方式");
        return;
      }
      this.regSubmit();
    },
    regSubmit() {
      this.$msg.loading();

      this.$http({
        url: this.$api.memberRegisterSubmitBaby,
        method: "post",
        data: {
          BabyName: this.dataList[0].list[0].value, //宝宝名称
          BabySexName: this.dataList[0].list[1].value, //宝宝性别
          BabyRelationship: this.dataList[0].list[2].value, //与宝宝关系
          BabyBirthday: this.dataList[0].list[3].value, //出生日期
          BabyBirthCertNo: this.dataList[0].list[4].value, //出生证号码
          BabyBirthCertImageFiles: this.dataList[0].list[5].value, //出生证照片
          FeedStyleName: this.dataList[0].list[6].value //喂养方式
        }
      }).then(res => {
        this.$msg.hideLoading();
        if (res.data.state == 1) {
          this.$router.push(
            "/ManyChildrenRegister/newMemberScan?activityOpenId=" +
              this.activeOpenid
          );
          return;
        }

        this.$msg.alert(res.data.msg);
      });
    }
  }
};
